/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiJingleCollectionsIdQueryResponse, GetApiJingleCollectionsIdPathParams, GetApiJingleCollectionsId400, GetApiJingleCollectionsId401, GetApiJingleCollectionsId403, GetApiJingleCollectionsId404, GetApiJingleCollectionsId500 } from "../../types/GetApiJingleCollectionsId.ts";
import { getApiJingleCollectionsIdQueryResponseSchema } from "../../zod/JingleCollectionSchemas/getApiJingleCollectionsIdSchema.ts";

function getGetApiJingleCollectionsIdUrl({ id }: { id: GetApiJingleCollectionsIdPathParams["Id"] }) {
  const res = { method: 'GET', url: `/api/jingle-collections/${id}` as const }  
  return res
}

/**
 * @summary Получение подборки джинглов по идентификатору
 * {@link /api/jingle-collections/:Id}
 */
export async function getApiJingleCollectionsId({ id }: { id: GetApiJingleCollectionsIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiJingleCollectionsIdQueryResponse, ResponseErrorConfig<GetApiJingleCollectionsId400 | GetApiJingleCollectionsId401 | GetApiJingleCollectionsId403 | GetApiJingleCollectionsId404 | GetApiJingleCollectionsId500>, unknown>({ method : "GET", url : getGetApiJingleCollectionsIdUrl({ id }).url.toString(), ... requestConfig })  
  return getApiJingleCollectionsIdQueryResponseSchema.parse(res.data)
}